import { render, staticRenderFns } from "./ProfAccountInformation.vue?vue&type=template&id=126a2328&"
import script from "./ProfAccountInformation.vue?vue&type=script&lang=js&"
export * from "./ProfAccountInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports